import { defineEndpoints } from '@blockworks/platform/api';

const INTERNAL_PRICE_CHART_ENDPOINTS = defineEndpoints(template => ({
    GET: {
        PRICE_CHART: template('/api/chart/price'),
    },
}));

export { INTERNAL_PRICE_CHART_ENDPOINTS };
